




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import supplierpo from "../../../store/entities/customer/supplierpo";
@Component
export default class CreateSupplier extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  supplier: supplierpo = new supplierpo();
  create() {}
  created() {
    this.supplier.isEnable = 1;
  }
  get list() {
    return this.$store.state.supplier.list;
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "supplier/create",
          data: this.supplier,
        });
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  itemRule = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
}
